import { createMultiStepFormContext } from '../../../providers/MultiStepForm.provider';

import type { NewBillingPackageData } from '../types';

const BillingPackageCreationContext = createMultiStepFormContext<NewBillingPackageData>();

export default BillingPackageCreationContext;
